import React from 'react';
import '../styles/Home.css';
import under from '../assets/under.jpg'

const Home = () => {
  console.log(Home); // ✅ This is valid — placed outside JSX

  return (
    <section className="hero">
      <h1>Welcome to ICITY Education</h1>
      <p>
        Empowering minds, shaping futures. Join thousands of students in their journey to excellence through innovative learning and professional development.
      </p>
      <div className="hero-buttons">
        <button>Explore Programs</button>
        <button>Get Started</button>
        <img src={under} alt="" className='web' />
      </div>
    </section>
  );
};

export default Home;
